import React from "react";
import Button from "../Button/Button";
import Checkbox from "../Checkbox/Checkbox";
import Datepicker from "../Datepicker/Datepicker";
import DurationSelectInput from "../DurationSelect/DurationSelect";
import FileField from "../FileField/FileField";
import InputField from "../InputField/InputField";
import LabelField from "../LabelField/LabelField";
import SelectField from "../SelectField/SelectField";
import Textarea from "../Textarea/Textarea";
import RichEditor from "../RichEditor/RichEditor";
import MultiSelectField from "../MultiSelectField/MultiSelectField";

const Activity = (props) => {
  const { presentationType, label, onBlur, onChange, choices } = props;
  const { multiple = false } = choices;

  const ACTIVITIES = {
    integer: <InputField {...props} type="text" />,
    choice: multiple ? (
      <MultiSelectField {...props} onChange={onChange} onBlur={onBlur} />
    ) : (
      <SelectField {...props} onChange={onChange} onBlur={onBlur} />
    ),
    checkbox: <Checkbox {...props} onChange={onBlur} />,
    textbox: <Textarea {...props} />,
    date: <Datepicker {...props} onChange={onBlur} />,
    datetime: <Datepicker {...props} onChange={onBlur} />,
    file: <FileField {...props} />,
    image: <FileField {...props} />,
    duration: (
      <DurationSelectInput {...props} onSubmit={(value) => onBlur(value)} />
    ),
    html: <RichEditor {...props} />,
    button: (
      <Button {...props} onClick={() => onBlur(props.value || "")}>
        {label}
      </Button>
    ),
    label: (
      <LabelField
        {...props}
        className={`${props.className} label-as-activity`}
      />
    ),
    error: (
      <LabelField {...props} className={`dcrform-error ${props.className}`} />
    ),
  };

  return ACTIVITIES[presentationType] || <InputField {...props} />;
};

export default Activity;
